<ui-data-table
  [title]="title()"
  [columns]="columns()"
  [rows]="displayRows()"
  [total]="total()"
  [loading]="loading()"
  [showNewButton]="false"
  [showStatusFilter]="false"
  [showActionsColumn]="false"
  (sortChange)="onSort($event)"
  (columnFiltersChange)="onFilter($event)"
  (exportExcel)="onExportExcel()"
/>
